import type { OrderOfferView } from '@khaddi/contracts';
import { Text, colors, formatVnd } from '@khaddi/ui';
import { Pressable, View } from 'react-native';

const shortKm = (km: number): string => `${km.toLocaleString('vi-VN', { maximumFractionDigits: 1 })}km`;

export const QueueRow = ({ offer, onPress }: { offer: OrderOfferView; onPress: () => void }) => (
  <Pressable
    accessibilityRole="button"
    accessibilityLabel={`Xem đơn ${offer.code}, ${offer.cupCount} ly, phí ${formatVnd(offer.fee)}`}
    onPress={onPress}
    style={({ pressed }) => ({
      backgroundColor: colors.surface,
      borderRadius: 16,
      paddingVertical: 12,
      paddingHorizontal: 14,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      minHeight: 64,
      transform: [{ scale: pressed ? 0.98 : 1 }],
    })}
  >
    <View style={{ width: 40, height: 40, borderRadius: 12, backgroundColor: colors.surfaceMuted, alignItems: 'center', justifyContent: 'center' }}>
      <Text variant="label" color={colors.primaryText} style={{ fontSize: 12, fontWeight: '800' }}>
        {shortKm(offer.dropoff.distanceKm)}
      </Text>
    </View>
    <View style={{ flex: 1, minWidth: 0 }}>
      <Text variant="bodyStrong" numberOfLines={1}>
        #{offer.code} · {offer.cupCount} ly
      </Text>
      <Text variant="caption" numberOfLines={1}>
        {offer.dropoff.area || offer.dropoff.address} · {offer.paymentLabel}
      </Text>
    </View>
    <Text variant="bodyStrong" numeric>
      {formatVnd(offer.fee)}
    </Text>
  </Pressable>
);
